import * as Cookies from 'es-cookie';
import { activateAllCategories, setFallbackActiveGroup } from 'basesiteScripts/oneTrust';

export function removeFallbackBanner() {
    const banner = document.getElementById('cookies-banner');

    if (banner) {
        banner.remove();
    }
}

/**
 * Initialize and display the EMEA cookie consent banner.
 */
export function initCookiesBanner() {
    const banner = document.getElementById('cookies-banner');

    if (!banner) {
        activateAllCategories();
        return;
    }

    if (!('remove' in Element.prototype)) {
        Element.prototype.remove = function () {
            if (this.parentNode) {
                this.parentNode.removeChild(this);
            }
        };
    }

    //Check to see if consent has already been given.  If so remove the banner.
    const fallbackCookieValue = Cookies.get('dssFallbackConsent');
    const oneTrustCookieValue = Cookies.get('OptanonConsent');
    const oneTrustBoxClosed = Cookies.get('OptanonAlertBoxClosed');

    setFallbackActiveGroup();

    if (!fallbackCookieValue && (!oneTrustBoxClosed || !oneTrustCookieValue)) {
        //Show the banner
        banner.classList.add('slideIn');
        const acceptBtn = document.getElementById('consent-accept');

        //Bind the click event of the accept button to save the cookie with a 6month expiry.
        acceptBtn.addEventListener('click', () => {
            Cookies.set('dssFallbackConsent', true, { expires: '' });
            activateAllCategories();
            window.AnalyticsManager.fireGlimpseEvent('consentGranted');
            banner.addEventListener('transitionend', e => {
                e.target.remove();
            });
            banner.classList.remove('slideIn');
        });
    } else {
        banner.remove();
    }
}
